// @ts-nocheck
import { Text, XStack, YStack } from 'tamagui';

import { useIsMobile } from '../hooks/useIsMobile';
import { Header, Footer } from '../components/landing';
import { SubscribeForm } from '../components/landing/SubscribeForm';

// Only list integrations that are actually built or in active development
const AVAILABLE = [
  { name: 'Gmail', category: 'Email', status: 'live' },
  { name: 'Google Drive', category: 'Storage', status: 'live' },
  { name: 'Google Calendar', category: 'Calendar', status: 'live' },
  { name: 'Slack', category: 'Messaging', status: 'live' },
  { name: 'Notion', category: 'Docs', status: 'live' },
  { name: 'GitHub', category: 'Development', status: 'live' },
  { name: 'Outlook', category: 'Email', status: 'live' },
  { name: 'OneDrive', category: 'Storage', status: 'live' },
  { name: 'Microsoft Teams', category: 'Messaging', status: 'live' },
  { name: 'Linear', category: 'Project Management', status: 'live' },
  { name: 'Jira', category: 'Project Management', status: 'coming' },
  { name: 'Confluence', category: 'Docs', status: 'coming' },
  { name: 'Salesforce', category: 'CRM', status: 'coming' },
  { name: 'HubSpot', category: 'CRM', status: 'coming' },
  { name: 'Figma', category: 'Design', status: 'coming' },
  { name: 'Asana', category: 'Project Management', status: 'coming' },
  { name: 'Trello', category: 'Project Management', status: 'coming' },
  { name: 'Dropbox', category: 'Storage', status: 'coming' },
  { name: 'Zendesk', category: 'Support', status: 'coming' },
  { name: 'Intercom', category: 'Support', status: 'coming' },
];

const live = AVAILABLE.filter((i) => i.status === 'live');
const coming = AVAILABLE.filter((i) => i.status === 'coming');

export default function IntegrationsPage() {
  const isMobile = useIsMobile();

  return (
    <YStack backgroundColor="$background" minHeight="100vh">
      <Header />

      <YStack
        paddingTop={isMobile ? 120 : 160}
        paddingBottom={isMobile ? 60 : 80}
        paddingHorizontal="$5"
        maxWidth={800}
        alignSelf="center"
        width="100%"
      >
        <YStack gap="$3" marginBottom="$10">
          <Text
            fontSize={isMobile ? 36 : 48}
            fontWeight="700"
            letterSpacing={-2}
            lineHeight={isMobile ? 40 : 54}
            color="$color12"
          >
            Integrations
          </Text>
          <Text fontSize={isMobile ? 16 : 18} color="$color8" lineHeight={28} maxWidth={520}>
            Connect the tools your team already uses. Torch searches across all of them with permissions-aware indexing.
          </Text>
        </YStack>

        {/* Live integrations */}
        <YStack gap="$4" marginBottom="$10">
          <Text fontSize="$2" fontWeight="600" color="$color7" textTransform="uppercase" letterSpacing={1.5}>
            Available now
          </Text>
          <XStack flexWrap="wrap" gap="$3">
            {live.map((item) => (
              <XStack
                key={item.name}
                paddingHorizontal="$4"
                paddingVertical="$3"
                borderRadius="$3"
                borderWidth={1}
                borderColor="$accentBackground"
                backgroundColor="$color2"
              >
                <Text fontSize={14} fontWeight="500" color="$color12">
                  {item.name}
                </Text>
              </XStack>
            ))}
          </XStack>
        </YStack>

        {/* Coming soon */}
        <YStack gap="$4" marginBottom="$10">
          <Text fontSize="$2" fontWeight="600" color="$color7" textTransform="uppercase" letterSpacing={1.5}>
            Coming soon
          </Text>
          <XStack flexWrap="wrap" gap="$3">
            {coming.map((item) => (
              <XStack
                key={item.name}
                paddingHorizontal="$4"
                paddingVertical="$3"
                borderRadius="$3"
                borderWidth={1}
                borderColor="$color4"
                backgroundColor="$color2"
              >
                <Text fontSize={14} fontWeight="500" color="$color8">
                  {item.name}
                </Text>
              </XStack>
            ))}
          </XStack>
        </YStack>

        {/* Request */}
        <YStack
          padding="$6"
          borderRadius="$3"
          borderWidth={1}
          borderColor="$color4"
          backgroundColor="$color2"
          gap="$4"
        >
          <Text fontSize={20} fontWeight="600" color="$color12" letterSpacing={-0.3}>
            Need a different integration?
          </Text>
          <Text fontSize={15} color="$color8" lineHeight={24}>
            Join the waitlist and tell us which tools you use. We prioritize integrations based on demand.
          </Text>
          <YStack maxWidth={400}>
            <SubscribeForm variant="compact" />
          </YStack>
        </YStack>
      </YStack>

      <Footer />
    </YStack>
  );
}
